import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const DarkModeToggle = ({ variant = 'default' }) => {
  const { isDarkMode, toggleDarkMode } = useTheme();

  // Different styles based on variant
  const buttonStyles = {
    default: `p-2 rounded-lg transition-all duration-300 ${
      isDarkMode 
        ? 'bg-gray-700 text-yellow-400 hover:bg-gray-600' 
        : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200'
    }`,
    nav: `p-2 rounded-lg transition-all duration-300 bg-transparent ${
      isDarkMode 
        ? 'text-yellow-400 hover:bg-white/10' 
        : 'text-[#FF6600] hover:bg-white/10'
    }`,
    minimal: `p-1.5 rounded-lg transition-all duration-300 ${
      isDarkMode 
        ? 'text-yellow-400 hover:bg-gray-700' 
        : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100'
    }`,
    dashboard: `p-2 rounded-lg transition-all duration-300 ${
      isDarkMode 
        ? 'bg-gray-800 text-yellow-400 hover:bg-gray-700 border border-gray-700' 
        : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700'
    }`,
  };

  return (
    <button
      onClick={toggleDarkMode}
      className={buttonStyles[variant] || buttonStyles.default}
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      data-testid="dark-mode-toggle"
    >
      {isDarkMode ? (
        <Sun size={20} className="transition-transform duration-300" />
      ) : (
        <Moon size={20} className="transition-transform duration-300" />
      )}
    </button>
  );
};

export default DarkModeToggle;
